export default __webpack_public_path__ + "static/community-hero-image-54304e0128ffc02ea549184bde67a4c2.jpg";